import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [impersonating, setImpersonating] = useState(!!localStorage.getItem("wl_admin_token"));

  useEffect(() => {
    const token = localStorage.getItem("wl_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("wl_token");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("wl_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("wl_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("wl_token");
    localStorage.removeItem("wl_admin_token");
    setImpersonating(false);
    setUser(null);
  };

  const impersonate = (data) => {
    localStorage.setItem("wl_admin_token", localStorage.getItem("wl_token"));
    localStorage.setItem("wl_token", data.token);
    setImpersonating(true);
    setUser(data.user);
    return data.user;
  };

  const stopImpersonate = () => {
    const adminToken = localStorage.getItem("wl_admin_token");
    if (adminToken) localStorage.setItem("wl_token", adminToken);
    localStorage.removeItem("wl_admin_token");
    setImpersonating(false);
    return api.get("/auth/me").then((res) => { setUser(res.data); return res.data; });
  };

  return (
    <AuthContext.Provider value={{ user, loading, impersonating, login, register, logout, impersonate, stopImpersonate }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export const roleHome = (role) =>
  ({ admin: "/admin", business: "/business", client: "/portal", driver: "/driver" }[role] || "/");
